module.exports = __webpack_public_path__ + "static/media/iceland-boat.40b5dea3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/iceland-boat.png
 ** module id = 185
 ** module chunks = 0
 **/